import { ChartContainer } from './ChartContainer';
import { Progress } from '../ui/progress';

export const GeoChart = ({ data }) => {
  const maxVisitors = Math.max(...data.map(d => d.visitors));
  
  return (
    <ChartContainer 
      title="Top Locations" 
      subtitle="Visitor geography"
    >
      <div className="space-y-4" data-testid="geo-chart">
        {data.map((item, index) => (
          <div key={index} className="space-y-2">
            <div className="flex items-center justify-between text-sm font-manrope">
              <span className="text-foreground">{item.country}</span>
              <span className="text-muted-foreground">
                {item.visitors.toLocaleString()} ({item.percentage}%)
              </span>
            </div>
            <div className="relative h-2 bg-secondary rounded-full overflow-hidden">
              <div 
                className="absolute inset-y-0 left-0 rounded-full transition-all duration-500"
                style={{ 
                  width: `${(item.visitors / maxVisitors) * 100}%`,
                  background: index === 0 
                    ? 'linear-gradient(90deg, hsl(42, 48%, 56%) 0%, hsl(42, 48%, 66%) 100%)'
                    : 'hsl(140, 25%, 55%)'
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </ChartContainer>
  );
};
